module.exports = __webpack_public_path__ + "static/media/the_path_to_the_river.adfbaf3c.jpg";